import { useTranslation } from '../i18n'
import classNames from 'classnames'

interface Props {
  className?: string
  text?: string
}

export default function Separator({ className, text }: Props) {
  const { t } = useTranslation()
  return (
    <div className={classNames('Separator', className)} role="separator">
      {text ?? t('common.or')}
    </div>
  )
}
